export default {
    filters: {
        invalid: 'Filters are invalid. Add missing values or remove incomplete filters.',
    },
    'record-view': {
        'automation-invalid': 'Automation is invalid',
        'fields-section-invalid': 'Fields section is invalid',
        'relation-section-invalid': 'Relation section is invalid',
        'custom-view-section-invalid': 'Custom view section is invalid',
        'attachments-section-invalid': 'Attachments section is invalid',
        'graph-section-invalid': 'Graph section is invalid',
        'activity-log-section-invalid': 'Activity log section is invalid',
    },
}
